import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './design/fonts'
import './design/tokens.css'
import './design/base.css'
import './design/indicators.css'
import './carta/LoginCard.css'
import './carta/LanguageSwitch.css'
import './carta/primitives.css'
import './carta/Hint.css'
import './carta/startPanel.css'
import './carta/rail.css'
import './style.css'
// Dopo `style.css`: il Cockpit e' l'unico schermo con una griglia propria, e le
// sue regole devono poter vincere su quelle generali senza alzare la specificita'
// a colpi di selettori.
import './cockpit/cockpit.css'
// La copertura ha un modulo proprio con bersagli piu' grandi: le sue regole
// devono poter vincere su quelle generali senza alzare la specificita' a colpi
// di selettori.
// La scheda dell'elemento: striscia dei fotogrammi e anagrafica a due colonne.
import './routes/element.css'
import './carta/lineMap.css'
import './map/map.css'
import './workspace/workspace.css'

const root = document.getElementById('root')
// Meglio fermarsi con una frase che montare su nulla: senza questo controllo
// la pagina resterebbe bianca senza dire perche'.
if (!root) throw new Error('manca il nodo #root nella pagina')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
